import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLDivElement> {
  close(): void {
    this.element.remove();
  }
}
